<template>
    <footer :class="$style.footer">
        <nav :class="$style.links">
            <Link
                v-for="link in links"
                :key="link.title"
                :to="link.to"
            >
                {{ link.title }}
            </Link>
        </nav>
        <Copyright :class="$style.copyright_override" />
    </footer>
</template>

<script lang="ts" setup>
import Copyright from '@/components/Copyright.vue'
import Link from '@/components/Link.vue'
import { ROUTE_NAMES } from '@/router/constants'

const links = [
    { title: 'Information for Parents', to: { name: ROUTE_NAMES.KIDS_PARENTS } },
    { title: 'Privacy Info for Kids', to: { name: ROUTE_NAMES.KIDS_PRIVACY_FOR_KIDS } },
    { title: 'Privacy Policy', to: { name: ROUTE_NAMES.KIDS_PRIVACY } },
    { title: 'Terms of Use', to: { name: ROUTE_NAMES.KIDS_TERMS_OF_USE } },
]
</script>

<style module>
.footer {
    border-top: 1px solid var(--white-08);
    margin-top: 96px;
    padding: 16px 0 24px;
}

.links {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 16px;
}

.links a {
    color: var(--white-60);
    font-size: var(--font-size-paragraph-s);
    line-height: var(--line-height-paragraph-s);
}

.copyright_override {
    margin-top: 16px;
}
</style>
